export default "__VITE_ASSET__BKHZ9EDw__"